"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = require("./theme");
function BlockQuote(_a) {
  var className = _a.className,
    style = _a.style,
    innerStyle = _a.innerStyle,
    children = _a.children;
  var border = theme_1.useBorderColor(className);
  return react_1.default.createElement("blockquote", {
    className: classnames_1.default('my-8 border-l-4 bg-gray-100 dark:bg-gray-100 rounded-lg shadow-lg', border),
    style: style,
    role: "alert"
  }, react_1.default.createElement("div", {
    className: "flex items-center px-4 py-2 leading-tight",
    style: innerStyle
  }, children));
}
exports.BlockQuote = BlockQuote;